import React, { useState, useEffect, useMemo, ChangeEvent } from 'react';
import { matchesBankSearchKeyword } from '@/common/models/banks/bankSearch';
import { fetchBankBranches } from '@/common/models/banks/bankClient';
import type { Bank } from '@/common/models/banks/bank';
import type { BankBranch } from '@/common/models/banks/bankBranch';
import { handleHttpError } from '@/common/http/errorHandler';
import { POPULAR_BANKS_VIEW } from './bankModalSteps';

interface Props {
  bank: Bank;
  onTransition: (view: number) => void;
  onChangeBranch: (branch: BankBranch) => void;
  onCancel: () => void;
}

export default function SelectBranchView({
  bank,
  onTransition,
  onChangeBranch,
  onCancel,
}: Props) {
  const [branches, setBranches] = useState<BankBranch[]>([]);
  const [keyword, setKeyword] = useState<string>('');

  useEffect(() => {
    fetchBankBranches(bank.id)
      .then(fetched => {
        setBranches(fetched);
      })
      .catch((error: unknown) => {
        handleHttpError(error);
      });
  }, [bank.id]);

  // branches の取得は非同期なので、絞り込みは branches と keyword から都度導出する。
  // キーワード入力時点で branches が未取得でも、取得完了後に再計算されて候補が出る。
  const appBranches = useMemo(() => {
    if (keyword === '') {
      return [];
    }

    return branches.filter(b => matchesBankSearchKeyword(b, keyword));
  }, [branches, keyword]);

  const onChangeKeyword = (event: ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  };

  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header text-center">
          <h5 className="modal-title w-100">支店を選択</h5>
          <button type="button" className="close" onClick={onCancel}>
            <span>&times;</span>
          </button>
        </div>
        <div className="modal-body p-40">
          <form>
            <div className="form-group">
              <label htmlFor="bank_branch">支店名で検索</label>
              <input
                id="bank_branch"
                type="text"
                className="form-control"
                placeholder="支店名を入力"
                value={keyword}
                onChange={onChangeKeyword}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </form>
          <div
            className="row bank-branch-select"
            data-testid="bank-branch-list"
          >
            {appBranches.map(b => (
              <div className="col-md-4 mb-20" key={b.id}>
                <button
                  type="button"
                  className="btn btn-lg btn-block btn-flat btn-outline-primary"
                  onClick={() => onChangeBranch(b)}
                >
                  {b.name}
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            className="btn btn-lg back-btn btn-outline-primary"
            onClick={() => onTransition(POPULAR_BANKS_VIEW)}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}
